import { shallowEqual } from 'react-redux';
import { Contact } from '../../../sic-lib/types/Contact';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { DrawerCommon } from '../../Shared/Drawer/DrawerCommon';
import NewCalendarEvent from './NewCalendarEvent/NewCalendarEvent';

interface Props {
    contact: Contact;
}

export default function CalendarNewEventDrawer({ contact }: Props) {
    const dispatch = useAppDispatch();

    const drawerOpen = useAppSelector(state => {
        return false; // state.calendar?.newEventDrawerOpen || false;
    }, shallowEqual);

    const handleHideCloseDrawer = () => {}; //dispatch(calendarActions.closeDrawerNewCalendarEvent());

    return (
        <DrawerCommon
            open={drawerOpen}
            handleOnClose={handleHideCloseDrawer}
            title="Schedule Calendar Event"
        >
            <NewCalendarEvent contact={contact} onCloseHandler={handleHideCloseDrawer} />
        </DrawerCommon>
    );
}
